import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';

import { negocio } from 'Infotrack@Modelos/conexiones';
import IAccionEtapaDocumentoCompuesto from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/administracion/IAccionEtapaDocumentoCompuesto';
import IAccionEtapaDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IAccionEtapaDocumento';

class ModeloAccionEtapaDocumento {
    private NOMBRE_CONTROLADOR = 'AccionEtapaDocumento';

    public async consultarAccionesDocumento(tipoDocumentoId: number) {
        return manejadorRest<IRespuesta<IAccionEtapaDocumentoCompuesto>>(
            () => negocio.get(`${this.NOMBRE_CONTROLADOR}/ConsultarAccionesDocumento/${tipoDocumentoId}`),
            true
        );
    }

    public async guardarAccionesEtapaDocumento(accionesEtapaDocumento: IAccionEtapaDocumento[]) {
        return manejadorRest<IRespuesta<IAccionEtapaDocumento>>(
            () => negocio.post(`${this.NOMBRE_CONTROLADOR}/GuardarAccionesEtapaDocumento`, accionesEtapaDocumento),
            true
        );
    }
}

export default ModeloAccionEtapaDocumento;
